module.exports = __webpack_public_path__ + "static/media/dientuDetail.03409143.png";